import { render, staticRenderFns } from "./UserHierachicView.vue?vue&type=template&id=b04d94e2&"
import script from "./UserHierachicView.vue?vue&type=script&lang=js&"
export * from "./UserHierachicView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports